const getMedia = size => `@media(max-width: ${size}px)`

export const media = {
  768: getMedia(768),
  500: getMedia(500),
}